import VTable from '@/vuetify_custom/v-table/v1'
import VPage from '@/vuetify_custom/v-pagination'
import AssetCheckListModal from './components/asset_check_list_modal.jsx'
import {VBtn} from 'vuetify/lib'
import {getAssetInventoryTopicListApi} from './service'
export default {
    data() {
        return {
            list: [],
            get_loading: false,
            params: {
                total_count:0,
                page:1,
                per_page:10,
            }
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: '批次名称',
                    value: 'name',
                    align: 'center',

                  },
                  {
                    text: '盘点开始日期',
                    align: 'center',
                    value: 'inventory_start',

                  },
                  {
                    text: '盘点结束日期',
                    value: 'inventory_end',
                    align: 'center',
        
                  },
                  {
                    text: '操作',
                    value: 'action',
                    type: 'button_g_field',
                    fixed: 'right',
                    width: 80,
                    buttons: [
                        {
                          text: '编辑',
                          key: 'edit',
                          color: 'primary',
                          small: true,
                          _text: true,
                          callback: (data) => {
                            this.$refs.modal.edit(data)
                         
                          }
                        },
                      ]
                  }
            ]
        }
    },
    created() {
        this.getData()
    },
    methods: {
        getData(params) {
            params = {...this.params, ...params}
            this.get_loading = true
            getAssetInventoryTopicListApi(params).then(res => {
                this.list = res.inventory_topics
              this.params = {
                page:res.cur_page,
                per_page: res.per_page,
                total_count: res.total_count
              }
            }).finally(() => {
                this.get_loading = false
            })
        },
    },
    render() {
        const _this = this
        return <div>
          <div>
            
            <VBtn 
                  color="primary" 
                  on={{click:() => {
                      _this.$refs.modal.edit()
                  }}} >新增</VBtn>
          </div>
            <VTable
                  headers={this.headers}
                  desserts={this.list}
                  loading={this.get_loading}
                  scopedSlots={{
                      name:(val, target) => {
                         
                        return <VBtn 
                        color="primary" 
                        text
                        on={{click:() => {
                            _this.$router.push(`/exec/assets/check_list/batch?id=${target.id}`)
                        }}} >{val}</VBtn>
                      }
                  }}
            />
            <div class="paginate-fix-bottom">
              {!!this.params.total_count && <VPage
                current={this.params.page}
                total={this.params.total_count}
                page-size={this.params.per_page}
                size-arr={[10, 20, 50]}
                on={
                  {
                    changePageSize:(per_page) => {
                      this.getData({
                        page:1,
                        per_page
                      })
                    },
                    pageChange:(page) => {
                      this.getData({
                        page
                      })
                    }
                  }
                }
              />}
            </div>
            <AssetCheckListModal on={{
                success: () => {
                    _this.getData({
                        page:1
                      })
                }
            }} ref="modal"/>
        </div>
    }
}